<template>
  <div class="legal">
    <section class="page-header">
      <div class="container">
        <h1>法律声明</h1>
        <p>请仔细阅读以下条款，使用本网站即表示您同意接受这些条款</p>
      </div>
    </section>

    <section class="content-section">
      <div class="container">
        <div class="content-wrapper">
          <div class="last-updated">
            <p>最后更新日期：2026年4月12日</p>
          </div>

          <div class="content-block">
            <h2>一、版权声明</h2>
            <p>本网站的所有内容，包括但不限于文字、图片、图表、标识、按钮图标、图像、声音、软件、数字下载、数据汇编以及网站设计、结构、选择、协调、表达等，均为企业名称或其内容提供商的财产，受中华人民共和国和国际版权法的保护。</p>
            <p>未经企业名称书面许可，任何单位或个人不得以任何方式复制、转载、引用、链接、抓取或以其他方式使用本网站的内容。违反上述声明者，本公司将依法追究其法律责任。</p>
          </div>

          <div class="content-block">
            <h2>二、商标声明</h2>
            <p>本网站使用的所有商标、服务标识、商号和标识（以下简称"商标"）均为企业名称或其关联公司的注册商标或商标。未经企业名称书面许可，任何单位或个人不得以任何方式使用本网站的商标。</p>
            <p>本网站提及的其他产品和公司名称可能是其各自所有者的商标。本网站的使用并不授予您使用这些商标的任何权利或许可。</p>
          </div>

          <div class="content-block">
            <h2>三、免责声明</h2>
            <h3>1. 信息准确性</h3>
            <p>本网站提供的所有信息仅供参考之用。尽管我们努力确保信息的准确性和完整性，但我们不保证本网站内容的准确性、完整性、可靠性、适用性或及时性。您使用本网站的内容完全由您自行承担风险。</p>

            <h3>2. 服务变更</h3>
            <p>我们保留随时修改或中断本网站服务（或其任何部分）的权利，无论是否提前通知。对于服务的任何修改、暂停或中断，我们不对您或任何第三方承担责任。</p>

            <h3>3. 第三方链接</h3>
            <p>本网站可能包含指向第三方网站或资源的链接。这些链接仅为方便您而提供，并不代表我们对这些第三方网站或资源的认可。我们对这些第三方网站或资源的内容、产品或服务不承担任何责任。</p>

            <h3>4. 技术故障</h3>
            <p>我们不保证本网站不间断、及时、安全或无错误。对于因技术故障、病毒、黑客攻击或其他原因导致的数据丢失或损坏，我们不承担责任。</p>
          </div>

          <div class="content-block">
            <h2>四、用户行为规范</h2>
            <p>使用本网站时，您同意遵守以下规定：</p>
            <ul>
              <li>不得使用本网站从事任何违法或违反公序良俗的活动；</li>
              <li>不得干扰或破坏本网站的服务或与本网站连接的服务器和网络；</li>
              <li>不得通过任何手段获取或试图获取未经授权的数据或信息；</li>
              <li>不得冒充任何个人或实体，或虚假陈述您与个人或实体的关系；</li>
              <li>不得上传、发布或传播任何虚假、欺诈、诽谤、淫秽或其他不当内容；</li>
              <li>不得使用任何机器人、蜘蛛、爬虫或其他自动化手段访问本网站。</li>
            </ul>
            <p>违反上述规定的，我们有权立即终止您对本网站的访问，并保留追究法律责任的权利。</p>
          </div>

          <div class="content-block">
            <h2>五、责任限制</h2>
            <p>在法律允许的最大范围内，企业名称及其董事、员工、代理人、供应商或内容提供商在任何情况下均不对因使用或无法使用本网站而产生的任何直接、间接、附带、特殊、惩罚性或后果性损害承担责任，包括但不限于利润损失、数据丢失、业务中断或其他无形损失。</p>
            <p>即使我们已被告知可能发生此类损害，上述责任限制仍然适用。某些司法管辖区不允许排除或限制某些损害的责任，因此上述限制可能不适用于您。</p>
          </div>

          <div class="content-block">
            <h2>六、赔偿</h2>
            <p>您同意赔偿并保护企业名称及其关联公司、董事、员工、代理人免受因以下原因产生的任何索赔、责任、损害、损失和费用（包括合理的律师费）：</p>
            <ul>
              <li>您对本网站的使用；</li>
              <li>您违反本法律声明的任何条款；</li>
              <li>您侵犯任何第三方的权利，包括知识产权或隐私权；</li>
              <li>您对本网站其他用户的任何有害行为。</li>
            </ul>
          </div>

          <div class="content-block">
            <h2>七、适用法律和争议解决</h2>
            <p>本法律声明受中华人民共和国法律管辖并依其解释，不考虑法律冲突原则。</p>
            <p>因本法律声明或您使用本网站而产生的任何争议，应首先通过友好协商解决。协商不成的，任何一方均可向企业名称所在地有管辖权的人民法院提起诉讼。</p>
          </div>

          <div class="content-block">
            <h2>八、条款修改</h2>
            <p>我们保留随时修改本法律声明的权利。修改后的条款将在本网站公布后立即生效。您在本法律声明修改后继续使用本网站，即表示您接受修改后的条款。我们建议您定期查看本页面以了解任何更改。</p>
          </div>

          <div class="content-block">
            <h2>九、可分割性</h2>
            <p>如果本法律声明的任何条款被认定为无效或不可执行，该条款应在必要的最小范围内被限制或删除，本法律声明的其他条款仍然完全有效。</p>
          </div>

          <div class="content-block">
            <h2>十、联系我们</h2>
            <p>如果您对本法律声明有任何疑问，请通过以下方式与我们联系：</p>
            <ul class="contact-list">
              <li>公司名称：广州爱匠文化有限公司</li>
              <li>电子邮箱：1002561026@qq.com</li>
            </ul>
          </div>


        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Legal'
}
</script>

<style scoped>
.legal {
  padding-top: 70px;
}

.page-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 80px 0;
  text-align: center;
}

.page-header h1 {
  font-size: 2.5rem;
  margin-bottom: 15px;
}

.page-header p {
  font-size: 1.1rem;
  opacity: 0.9;
}

.container {
  max-width: 900px;
  margin: 0 auto;
  padding: 0 20px;
}

.content-section {
  padding: 60px 0 100px;
  background: #f8f9fa;
}

.content-wrapper {
  background: #fff;
  padding: 60px;
  border-radius: 20px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
}

.last-updated {
  text-align: right;
  color: #999;
  font-size: 0.9rem;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
}

.content-block {
  margin-bottom: 40px;
}

.content-block:last-child {
  margin-bottom: 0;
}

.content-block h2 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #667eea;
  display: inline-block;
}

.content-block h3 {
  font-size: 1.2rem;
  color: #444;
  margin: 25px 0 15px;
}

.content-block p {
  color: #666;
  line-height: 1.8;
  margin-bottom: 15px;
}

.content-block ul {
  margin-left: 20px;
  margin-bottom: 15px;
}

.content-block li {
  color: #666;
  line-height: 1.8;
  margin-bottom: 10px;
}

.contact-list {
  background: #f8f9fa;
  padding: 20px 20px 20px 40px;
  border-radius: 10px;
  margin: 20px 0;
}

.contact-list li {
  margin-bottom: 8px;
}

.license-info {
  background: #f8f9fa;
  padding: 25px;
  border-radius: 10px;
  margin: 20px 0;
}

.license-info p {
  margin-bottom: 12px;
}

.license-info p:last-child {
  margin-bottom: 0;
}

.license-note {
  color: #999;
  font-size: 0.9rem;
  font-style: italic;
}

@media (max-width: 768px) {
  .page-header h1 {
    font-size: 1.8rem;
  }
  
  .content-wrapper {
    padding: 30px 20px;
  }
  
  .content-block h2 {
    font-size: 1.3rem;
  }
}
</style>
